export default __webpack_public_path__ + "static/freshsalesCrmImage-d3995589a234c7fcf424d9b198ab4f66.webp";